// components/Analytics/DevicePieChart.js
import { Chart } from 'primereact/chart';
import { getStableColor } from '../analyticsColors';

function PieChart({ data, config }) {

  if (!data || !data.labels || !data.datasets?.length) {
    return null;
  }
  const options = { responsive: true, maintainAspectRatio: false };

  const sourceDataset = data.datasets[0];

  const backgroundColor = data.labels.map((label) =>
    getStableColor(label)
  );

  const borderColor = data.labels.map(() =>
    '#ffffff'
  );


  const chartData = {
    labels: data.labels,

    datasets: [
      {
        ...sourceDataset,

        backgroundColor,
        borderColor,

        borderWidth: 2,
        borderRadius: 5,
      }
    ]
  };


  return (
    <Chart
      type={config.type || 'doughnut'}
      data={chartData}
      options={options}
      height={300}
    />
  );
}

export default PieChart;